import { useDispatch, useSelector } from 'react-redux'
import { EnvironmentalTitle } from '../../components/EnvironmentalTitle/EnvironmentalTitle'
import { NavBar } from '../../components/NavBar/NavBar'
import { DashboardWrapper } from './Environmental.styled'
import GoogleMapReact from 'google-map-react'
import { useState } from 'react'
import { useQuery } from '@apollo/client'
import { AppDispatch, RootState } from 'store'
import { GET_LIST_RECLAMATIONS_BY_COMPANY_ID, GET_COMPANY_BY_ID } from '../../graphql'
import { setSelectedCompany } from 'features/companies/companiesSlice'

// const etas = [
//   {
//     areaColor: '#FF9900',
//     borderColor: '#FF9900',
//     description: 'Test',
//     driverTeamId: '',
//     driversCount: 1,
//     geofenceId: '-Mt_rdVv_n95Czn4aVUI',
//     regionName: 'MT',
//     studRoutes: [
//       { lat: 57.51643389921027, lng: -103.90738027808212 },
//       { lat: 25.64255205723647, lng: -98.45816152808212 },
//       { lat: 47.399119323376574, lng: -25.157380278082123 },
//       { lat: 62.10441482955105, lng: -66.64175527808212 },
//       { lat: 58.35622726436298, lng: -98.45816152808212 },
//     ],
//     updatedTimestamp: 1658156544,
//   },
// ];

const markerPosition = { lat: 6.290693, lng: -0.507038 }

export const Environmental = () => {
  //   const [polygons, setPolygons] = useState([]);
  const [googleMap, setMap] = useState()

  //   useEffect(() => {
  //     polygons.forEach((p) => p.setMap(null));
  //     setPolygons([]);
  //     if (googleMap) {
  //       const newPolygons = etas.map((eta, idx) => createPolygon(eta, idx));
  //       setPolygons(newPolygons);
  //     }

  //     console.log(etas);
  //   }, [etas, googleMap]);

  //   const createPolygon = (eta) => {
  //     const polygon = new window.google.maps.Polygon({
  //       paths: eta.studRoutes?.map(
  //         (r) => new window.google.maps.LatLng(r.lat, r.lng)
  //       ),
  //       strokeColor: eta.borderColor,
  //       strokeOpacity: 0.8,
  //       strokeWeight: 1,
  //       fillColor: eta.areaColor,
  //       fillOpacity: 0.35,
  //       regionName: eta.regionName,
  //       map: googleMap,
  //       geofenceId: eta.geofenceId,
  //     });

  //     // window.google.maps.event.addListener(polygon, 'mouseover', () => {
  //     //   setRegionName(polygon.regionName);
  //     //   setShowTooltip(true);
  //     //   polygon.setOptions({ fillOpacity: 0.6 });
  //     // });

  //     // window.google.maps.event.addListener(polygon, 'mouseout', () => {
  //     //   setShowTooltip(false);
  //     //   polygon.setOptions({ fillOpacity: 0.35 });
  //     // });

  //     // window.google.maps.event.addListener(polygon, 'click', () => {
  //     //   if (selectedEta?.geofenceId === polygon.geofenceId) {
  //     //     setSelectedEta(null);
  //     //   } else {
  //     //     setSelectedEta(
  //     //       etas.filter((x) => x.geofenceId === polygon.geofenceId)[0]
  //     //     );
  //     //   }
  //     // }
  //     // );
  //     return polygon;
  //   };
  interface MapProps {
    map: any
  }

  const onMapLoaded = ({ map }: MapProps) => {
    const leftButton = document.createElement('div')
    // MapButton(leftButton, () => setIsMapStreched((p) => !p));
    map?.controls[window.google.maps.ControlPosition.TOP_LEFT].push(leftButton)

    setMap(map)

    console.log(map)
  }
  const { selectedCompany } = useSelector((state: RootState) => state.companies)
  const companyById = useQuery(GET_COMPANY_BY_ID, { skip: true })
  const { loading, data } = useQuery(GET_LIST_RECLAMATIONS_BY_COMPANY_ID, {
    variables: { companyId: selectedCompany ? selectedCompany.id : '' },
  })
  const dispatch = useDispatch<AppDispatch>()
  const handleCompanyChange = async (company) => {
    const comp = await companyById.refetch({ companyId: company.id })
    dispatch(setSelectedCompany(comp.data.getCompanyById))
  }
  return (
    <>
      <DashboardWrapper>
        <NavBar handleCompanyChange={handleCompanyChange} />
        <EnvironmentalTitle />

        <div
          style={{
            width: '100%',
            position: 'relative',
            borderRadius: '12px',
            overflow: 'hidden',
            marginTop: '1rem',
          }}
        >
          <GoogleMapReact
            style={{
              width: '100%',
              height: '75vh',
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
            bootstrapURLKeys={{
              key: 'AIzaSyDBluVqssEGhqrn5u6QiqFBu-oEXUIOkDI',
            }}
            defaultCenter={{
              lat: 6.290693,
              lng: -0.507038,
            }}
            defaultZoom={16}
            yesIWantToUseGoogleMapApiInternals
            onGoogleApiLoaded={({ map }) => onMapLoaded(map)}
            options={(map) => ({ mapTypeId: map.MapTypeId.SATELLITE })}
          >
            {/* {Object.values(tasksMarkers).map((marker, i) => {
              if (marker.length === 1) {
                return ( */}
            <Marker
              // key={i + 20}
              // {...marker[0]}

              {...markerPosition}
            />
            {/* );
              }
            })} */}
          </GoogleMapReact>
        </div>
      </DashboardWrapper>
    </>
  )
}
interface MarkerProps {
  lat: number
  lng: number
}
const Marker = ({}: MarkerProps) => (
  <svg
    width='134'
    height='157'
    viewBox='0 0 134 157'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g filter='url(#filter0_d_1_172)'>
      <rect x='30' y='30' width='74' height='97' rx='14' fill='#FF9900' />
    </g>
    <path
      d='M47.7989 81.6777C47.7989 82.837 48.7211 83.7801 49.8546 83.7801C50.9881 83.7801 51.9102 82.837 51.9102 81.6777C51.9102 80.9299 51.5168 80.2325 50.8837 79.8575C50.5721 79.673 50.2162 79.5753 49.8546 79.5753C48.7211 79.5753 47.7989 80.5185 47.7989 81.6777ZM50.5981 81.6777C50.5981 82.097 50.2645 82.4382 49.8546 82.4382C49.4446 82.4382 49.111 82.097 49.111 81.6777C49.111 81.2584 49.4446 80.9173 49.8546 80.9173C49.9856 80.9173 50.114 80.9524 50.2261 81.0188C50.4556 81.1546 50.5981 81.4072 50.5981 81.6777Z'
      fill='white'
    />
    <path
      d='M55.4534 83.7801C56.5869 83.7801 57.509 82.837 57.509 81.6777C57.509 80.9299 57.1157 80.2325 56.4825 79.8575C56.1708 79.673 55.815 79.5753 55.4534 79.5753C54.3199 79.5753 53.3977 80.5185 53.3977 81.6777C53.3977 82.837 54.3199 83.7801 55.4534 83.7801ZM55.4534 80.9173C55.5844 80.9173 55.7128 80.9524 55.825 81.0188C56.0544 81.1547 56.1969 81.4072 56.1969 81.6777C56.1969 82.097 55.8634 82.4382 55.4534 82.4382C55.0434 82.4382 54.7098 82.097 54.7098 81.6777C54.7098 81.2584 55.0434 80.9173 55.4534 80.9173Z'
      fill='white'
    />
    <path
      d='M61.0511 83.7801C62.1847 83.7801 63.1068 82.837 63.1068 81.6777C63.1068 80.9299 62.7134 80.2325 62.0803 79.8575C61.7686 79.673 61.4128 79.5753 61.0511 79.5753C59.9176 79.5753 58.9955 80.5185 58.9955 81.6777C58.9955 82.837 59.9176 83.7801 61.0511 83.7801ZM61.0511 80.9173C61.1822 80.9173 61.3106 80.9524 61.4227 81.0188C61.6522 81.1547 61.7947 81.4072 61.7947 81.6777C61.7947 82.097 61.4611 82.4382 61.0511 82.4382C60.6412 82.4382 60.3076 82.097 60.3076 81.6777C60.3076 81.2584 60.6412 80.9173 61.0511 80.9173Z'
      fill='white'
    />
    <path
      d='M66.65 83.7801C67.7835 83.7801 68.7056 82.837 68.7056 81.6777C68.7056 80.9299 68.3123 80.2325 67.6791 79.8575C67.3674 79.673 67.0116 79.5753 66.65 79.5753C65.5165 79.5753 64.5943 80.5185 64.5943 81.6777C64.5943 82.837 65.5165 83.7801 66.65 83.7801ZM66.65 80.9173C66.781 80.9173 66.9094 80.9524 67.0216 81.0188C67.251 81.1547 67.3935 81.4072 67.3935 81.6777C67.3935 82.097 67.06 82.4382 66.65 82.4382C66.24 82.4382 65.9064 82.097 65.9064 81.6777C65.9064 81.2584 66.24 80.9173 66.65 80.9173Z'
      fill='white'
    />
    <path
      d='M50.5546 70.1803H51.2544C51.6168 70.1803 51.9105 69.8799 51.9105 69.5093C51.9105 69.1387 51.6168 68.8383 51.2544 68.8383H50.5546C50.1923 68.8383 49.8986 69.1387 49.8986 69.5093C49.8986 69.8799 50.1923 70.1803 50.5546 70.1803Z'
      fill='white'
    />
    <path
      d='M50.5546 72.3277H51.2544C51.6168 72.3277 51.9105 72.0273 51.9105 71.6567C51.9105 71.2862 51.6168 70.9857 51.2544 70.9857H50.5546C50.1923 70.9857 49.8986 71.2862 49.8986 71.6567C49.8986 72.0273 50.1923 72.3277 50.5546 72.3277Z'
      fill='white'
    />
    <path
      d='M88.7217 65.5914L77.5657 44.0322C77.1363 43.0461 76.1695 42.3565 75.0477 42.3565C74.1082 42.3565 73.2774 42.8402 72.7798 43.5766C72.7787 43.5781 72.7775 43.5794 72.7763 43.5809L62.1012 58.1322C61.9537 58.1126 61.8042 58.102 61.653 58.102H56.8529C54.9477 58.102 53.3976 59.6873 53.3976 61.6358V65.9748H49.1551C48.0216 65.9748 47.0994 66.9179 47.0994 68.0772V73.0871C47.0994 74.2464 48.0216 75.1895 49.1551 75.1895H54.0537H54.7972V76.7104H49.8549C47.1779 76.7104 45 78.9377 45 81.6756C45 84.4134 47.1779 86.6408 49.8549 86.6408H66.6501C69.3271 86.6408 71.505 84.4134 71.505 81.6756C71.505 78.9377 69.3271 76.7104 66.6501 76.7104H61.7078V75.1895H67.3499C67.7122 75.1895 68.006 74.8891 68.006 74.5185V72.3268L68.7496 72.3267C68.7584 72.3267 68.767 72.3257 68.7757 72.3253C68.7894 72.3248 68.8031 72.3246 68.8166 72.3232C68.8235 72.3225 68.8301 72.321 68.8369 72.3201C68.8518 72.318 68.867 72.3161 68.8816 72.3131C68.8935 72.3106 68.905 72.307 68.9167 72.3039C68.9259 72.3014 68.9354 72.2994 68.9445 72.2965C68.9517 72.2942 68.9585 72.2912 68.9656 72.2887C68.9788 72.284 68.992 72.2795 69.0048 72.274C69.0062 72.2734 69.0076 72.2725 69.0092 72.2718C69.0468 72.2552 69.0827 72.2353 69.1162 72.2122C69.1246 72.2064 69.1325 72.1997 69.1406 72.1936C69.1494 72.1869 69.1584 72.1807 69.1668 72.1736C69.1757 72.1661 69.1839 72.1578 69.1924 72.1498C69.1994 72.1433 69.2066 72.1371 69.2134 72.1303C69.2195 72.124 69.2249 72.1172 69.2308 72.1107C69.2392 72.1014 69.2478 72.0924 69.2557 72.0826C69.2586 72.079 69.2611 72.0751 69.2639 72.0714C69.2741 72.0582 69.2842 72.045 69.2934 72.0309C69.2976 72.0246 69.3011 72.0178 69.3051 72.0112C69.3124 71.9995 69.3198 71.9879 69.3263 71.9756C69.3631 71.9065 69.3875 71.8296 69.3986 71.7484C69.4027 71.7181 69.4056 71.6873 69.4056 71.6558V69.095C69.4056 67.8279 69.0424 66.601 68.3551 65.5467L67.3153 63.9518L74.523 51.576L85.1682 67.7023C85.4168 68.1378 85.814 68.4739 86.2883 68.6378V69.7457L86.0969 69.2585C86.032 69.0934 85.9057 68.9614 85.7457 68.8916C85.5856 68.8216 85.4049 68.8197 85.2436 68.886L76.2777 72.5697L74.7331 71.2673C74.4535 71.0315 74.04 71.0722 73.8095 71.3582C73.579 71.6441 73.6188 72.067 73.8984 72.3027L78.7408 76.3856C79.6256 77.1316 80.7204 77.5201 81.829 77.5201C82.439 77.5201 83.0534 77.4024 83.6389 77.1618L85.8715 76.2445C86.8341 75.849 87.459 74.957 87.5785 73.9719C87.5923 73.9178 87.6004 73.8613 87.6004 73.8028V68.6378C88.413 68.357 89 67.5705 89 66.6458C89 66.2617 88.8983 65.9016 88.7217 65.5914ZM53.3976 73.8476H49.1551C48.7451 73.8476 48.4115 73.5064 48.4115 73.0871V68.0772C48.4115 67.6579 48.7451 67.3167 49.1551 67.3167H53.3976V73.8476ZM85.3824 74.9993L83.1498 75.9166C81.9461 76.4112 80.5765 76.1942 79.5755 75.3501L77.431 73.542L85.1239 70.3813L86.1836 73.0792C86.4804 73.8346 86.1208 74.6959 85.3824 74.9993ZM75.0477 43.6985C75.5877 43.6985 76.0587 44.0038 76.3061 44.454C76.3159 44.4805 76.3268 44.5068 76.3401 44.5326L76.3823 44.6143C76.452 44.7872 76.4911 44.9763 76.4911 45.1746C76.4911 45.4535 76.4136 45.7137 76.2816 45.9365C76.2774 45.9431 76.2729 45.9493 76.2689 45.9561L76.2414 46.0032C75.9814 46.3937 75.5434 46.6507 75.0477 46.6507C74.2519 46.6507 73.6044 45.9885 73.6044 45.1746C73.6044 44.3607 74.2519 43.6985 75.0477 43.6985ZM66.6501 78.0523C68.6036 78.0523 70.1928 79.6777 70.1928 81.6756C70.1928 83.6735 68.6036 85.2988 66.6501 85.2988H49.8549C47.9014 85.2988 46.3121 83.6735 46.3121 81.6756C46.3121 79.6777 47.9014 78.0523 49.8549 78.0523H66.6501ZM56.1093 76.7104V75.1895H60.3956V76.7104H56.1093ZM66.6938 73.8476H54.7097V66.6493C54.7097 66.6481 54.7099 66.647 54.7099 66.6458C54.7099 66.6445 54.7097 66.6434 54.7097 66.6423V61.6358C54.7097 60.6612 55.3351 59.8335 56.1968 59.5495V69.1872C56.1968 69.9856 56.6577 70.711 57.371 71.0352C59.2563 71.8922 61.2581 72.3267 63.3212 72.3267H66.6938V73.8476ZM68.0934 69.0949V70.9847H63.3212C62.5392 70.9847 61.7671 70.9151 61.008 70.7788V61.6358C61.008 61.2653 60.7142 60.9649 60.3519 60.9649C59.9896 60.9649 59.6958 61.2653 59.6958 61.6358V70.4716C59.0876 70.2954 58.4895 70.0751 57.904 69.8089C57.664 69.6999 57.5089 69.4558 57.5089 69.1872V59.444H61.6531C62.3713 59.444 63.0379 59.8089 63.4363 60.42L67.2634 66.291C67.8064 67.1241 68.0934 68.0937 68.0934 69.0949ZM66.5088 62.7144L64.528 59.6756C64.2336 59.224 63.8477 58.857 63.4052 58.5907L72.4865 46.2119C72.8914 47.2538 73.8865 47.9927 75.0477 47.9927C75.0596 47.9927 75.0714 47.9919 75.0832 47.9918L66.5088 62.7144ZM85.2598 65.4428L75.2651 50.3019L77.363 46.6998C77.3812 46.671 77.3991 46.642 77.4164 46.6125L86.7026 64.5585C86.1067 64.6302 85.5882 64.9634 85.2598 65.4428ZM86.9443 67.4062C86.5343 67.4062 86.2008 67.0651 86.2008 66.6458C86.2008 66.2265 86.5343 65.8853 86.9443 65.8853C87.3543 65.8853 87.6879 66.2265 87.6879 66.6458C87.6879 67.0651 87.3543 67.4062 86.9443 67.4062Z'
      fill='white'
    />
    <path
      d='M45.4714 101.154V98.274H50.6194V111H47.3794V101.154H45.4714ZM51.8875 101.154V98.274H57.0355V111H53.7955V101.154H51.8875ZM58.8615 104.502C58.8615 106.494 59.2635 108.072 60.0675 109.236C60.8715 110.4 62.1555 110.982 63.9195 110.982C65.6715 110.982 66.9495 110.4 67.7535 109.236C68.5695 108.072 68.9775 106.494 68.9775 104.502C68.9775 102.522 68.5695 100.956 67.7535 99.804C66.9495 98.64 65.6715 98.058 63.9195 98.058C62.1555 98.058 60.8715 98.64 60.0675 99.804C59.2635 100.956 58.8615 102.522 58.8615 104.502ZM65.9175 104.502C65.9175 105.642 65.7795 106.524 65.5035 107.148C65.2395 107.76 64.7115 108.066 63.9195 108.066C63.1155 108.066 62.5755 107.76 62.2995 107.148C62.0235 106.524 61.8855 105.642 61.8855 104.502C61.8855 103.374 62.0235 102.504 62.2995 101.892C62.5755 101.28 63.1155 100.974 63.9195 100.974C64.7115 100.974 65.2395 101.28 65.5035 101.892C65.7795 102.492 65.9175 103.362 65.9175 104.502ZM83.7655 100.848C85.0015 100.848 85.9735 101.232 86.6815 102C87.3895 102.756 87.7435 103.812 87.7435 105.168V111H84.6835V105.528C84.6835 104.892 84.5095 104.4 84.1615 104.052C83.8255 103.692 83.3635 103.512 82.7755 103.512C82.1635 103.512 81.6775 103.704 81.3175 104.088C80.9695 104.46 80.7955 104.988 80.7955 105.672V111H77.7175V105.528C77.7175 104.892 77.5495 104.4 77.2135 104.052C76.8775 103.692 76.4155 103.512 75.8275 103.512C75.2155 103.512 74.7295 103.698 74.3695 104.07C74.0095 104.442 73.8295 104.976 73.8295 105.672V111H70.7515V100.956H73.8295V102.666C74.0935 102.102 74.4955 101.658 75.0355 101.334C75.5875 101.01 76.2295 100.848 76.9615 100.848C77.7295 100.848 78.4075 101.028 78.9955 101.388C79.5835 101.736 80.0275 102.24 80.3275 102.9C80.6755 102.276 81.1495 101.778 81.7495 101.406C82.3615 101.034 83.0335 100.848 83.7655 100.848Z'
      fill='white'
    />
    <path d='M66.5 141L57.4067 125.25L75.5933 125.25L66.5 141Z' fill='#FF9900' />
    <defs>
      <filter
        id='filter0_d_1_172'
        x='0'
        y='0'
        width='134'
        height='157'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset />
        <feGaussianBlur stdDeviation='15' />
        <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0' />
        <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_1_172' />
        <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_1_172' result='shape' />
      </filter>
    </defs>
  </svg>
)
